export class SlackChannelNotFoundError extends Error {}
